module.exports = {"id":"198000","name":"Justin Morrow","rating":"71","photo":"./data/images/photos/2/198000.png","club":{"name":"Toronto FC","logo":"./data/images/clubs/TorontoFC.png"},"positions":["DG","DLG","MG","DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JustinMorrow0.json
// module id = 2270
// module chunks = 0